import { Observable } from '@helpcenter/epics-rxjs';
import { post } from 'epics/ajax';
import { trackError } from '@atlassian/help-center-common-util/analytics';
import { contextPath } from '@atlassian/help-center-common-util/history';

export interface SaveAttachmentResponse {
    attachmentId: string;
}

const saveAttachment = (portalId: number, fileId: string): Observable<SaveAttachmentResponse> => {
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return post(
        `${contextPath}/rest/servicedesk/1/customer/portal/${portalId}/media/upload`,
        {
            fileId,
        },
        {
            'Content-Type': 'application/json',
        }
    )
        .map((res) => ({
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            attachmentId: res.response.attachmentId,
        }))
        .catch((res) => {
            trackError('attachment.save.failed', {}, res);

            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            const errors = res.response.errors;

            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            const error = errors && errors.length && errors[0].errorMessage;
            return Observable.throw(error);
        });
};

export default saveAttachment;
